import { createSlice } from "@reduxjs/toolkit";

const initialSystemLogsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const systemLogSlice = createSlice({
  name: "systemLogs",
  initialState: initialSystemLogsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSystemLogs
    systemLogsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getException
    exceptionFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.exception = action.payload.entity;
    },
    // cleanException
    exceptionStateCleaned: (state) => {
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.exception = undefined;
    },
    // cleanSystemLogsState
    systemLogsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});